export const sideMenuList = {
  Templates: "Templates",
  Photos: "Photos",
  Elements: "Elements",
  Text: "Text",
  Videos: "Videos",
  Bkground: "Bkground",
  Uploads: "Uploads",
  Folders: "Folders",
  More: "More",
};

export const imageURLList = [
  "https://img.icons8.com/fluent/96/000000/bar-chart.png",
  "https://img.icons8.com/color/96/000000/doughnut-chart--v1.png",
];
